import * as _ from 'lodash';

function NotificationResp(data, retailer, retailers, user) {
  this.data = data;
  this.retailer = retailer;
  this.retailers = retailers;
  this.user = user;
}

NotificationResp.prototype.prepareNotifications = function() {
  let result = [];
  var that = this;
  _.each(this.data, function(notificationType) {
    if (!that.retailer.id) {
      result.push(that.prepareAllRetailers(notificationType));
    } else {
      result.push(that.prepareIndividualRetailer(notificationType));
    }
  });
  return result;
};

NotificationResp.prototype.prepareIndividualRetailer = function(notificationType) {
  var that = this;
  var defaultType = _.cloneDeep(notificationType);
  if(this.user?.disable_notifications_by_default) {
    defaultType['email_preference'] = false;
    defaultType['phone_preference'] = false;
  }
  return _.filter(notificationType.preferences, function(p) {
           return p.retailer_id == that.retailer.id;
         })[0] || defaultType;
};

NotificationResp.prototype.prepareAllRetailers = function(notificationType) {
  var that = this;
  var n = _.cloneDeep(notificationType);
  if (n.preferences.length > 0) {
    _.each(['email_preference', 'phone_preference'], function(prefName) {
      var helpTextKey = 'someSetHelpText_' + prefName;
      n[prefName] = _.every(n.preferences, that.matchPref(prefName));

      if (that.needHelpText(n, notificationType, prefName)) {
        n[helpTextKey] = _.filter(n.preferences, that.matchPref(prefName)).length;

        if (that.defaultsSetForSome(notificationType, prefName)) {
          n[helpTextKey] += that.retailers.length - n.preferences.length - 1;
        }
      }
    });
  } else if(this.user?.disable_notifications_by_default) {
    n["email_preference"] = false;
    n["phone_preference"] = false;
  }
  return n;
};

NotificationResp.prototype.needHelpText = function(n, notificationType, prefName) {
  var that = this;
  return (!n[prefName] && _.some(notificationType.preferences, that.matchPref(prefName))) ||
    that.defaultsSetForSome(notificationType, prefName);
};

NotificationResp.prototype.defaultsSetForSome = function(notificationType, prefName) {
  return notificationType[prefName] && (notificationType.preferences.length < this.retailers.length);
};

NotificationResp.prototype.matchPref = function(prefName) {
  return function(p) { return p[prefName]; };
};

const prepare = function(data, retailer, retailers, user) {
  var resp = new NotificationResp(data, retailer, retailers, user);
  return resp.prepareNotifications();
}

export default prepare;